import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import { TechnicalPause } from "@features";
import { Footer, Header } from "@widgets";
import classNames from "classnames";
import { ScrollButton } from "src/widgets/ScrollButton";
import { AppState } from "@app/store/store";
import { TemplateProps } from "@app/Template/TemplateProps";
import CallbackForm from "@features/callback-form/callback-form-button";
import { CookieConsent } from "@features/cookie-consent/CookieConsent";
import { useCopyWithSource } from "@features/copy-with-source";
import classes from "./Template.module.scss";

const DynamicToast = dynamic(() => import("@shared/ui/Toast").then((mod) => mod.Toast), {
    ssr: false
});
const Modals = dynamic(() => import("@components/Features/Modals/Modals"), { ssr: false });

const Template: React.FC<React.PropsWithChildren<TemplateProps>> = ({ children, bgColor }) => {
    const isOnTechnicalPause = useSelector((state: AppState) => state.layout.technicalPause);
    const footerVisible = useSelector((state: AppState) => state.layout.footerVisible);
    const containerClasses = classNames(classes.Container, {
        [classes.Container__blue]: bgColor === "blue",
        [classes.Container__white]: bgColor === "white"
    });

    const callbackFormVisible = useSelector((state: AppState) => state.layout.callbackFormVisible);

    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        if (typeof window !== "undefined") {
            setIsClient(true);
        } else {
            setIsClient(false);
        }
    }, []);

    useCopyWithSource();

    return (
        <main className={`${classes.Template}`}>
            <Modals />
            <Header />
            <div className={containerClasses} style={{}}>
                {isOnTechnicalPause ? <TechnicalPause /> : children}
            </div>
            {footerVisible && <Footer />}
            {isClient && <DynamicToast />}
            {!callbackFormVisible && <CallbackForm />}
            <ScrollButton />
            <CookieConsent />
        </main>
    );
};

export default Template;